/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PowercurveDataRequest
 */
export interface PowercurveDataRequest {
    /**
     * 
     * @type {number}
     * @memberof PowercurveDataRequest
     */
    timeFrom: number;
    /**
     * 
     * @type {number}
     * @memberof PowercurveDataRequest
     */
    timeTo: number;
    /**
     * 
     * @type {number}
     * @memberof PowercurveDataRequest
     */
    windInterval?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PowercurveDataRequest
     */
    filterNegativePower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PowercurveDataRequest
     */
    filterNegativeWind?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PowercurveDataRequest
     */
    filterNoPowerValues?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PowercurveDataRequest
     */
    filterRefCurveTolerance?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRequest
     */
    hours?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PowercurveDataRequest
     */
    generatorStatus?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PowercurveDataRequest
     */
    windDirections?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PowercurveDataRequest
     */
    windDirectionSteps?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PowercurveDataRequest
     */
    generatorKeys: Array<string>;
}

/**
 * Check if a given object implements the PowercurveDataRequest interface.
 */
export function instanceOfPowercurveDataRequest(value: object): value is PowercurveDataRequest {
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    if (!('generatorKeys' in value) || value['generatorKeys'] === undefined) return false;
    return true;
}

export function PowercurveDataRequestFromJSON(json: any): PowercurveDataRequest {
    return PowercurveDataRequestFromJSONTyped(json, false);
}

export function PowercurveDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PowercurveDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timeFrom': json['timeFrom'],
        'timeTo': json['timeTo'],
        'windInterval': json['windInterval'] == null ? undefined : json['windInterval'],
        'filterNegativePower': json['filterNegativePower'] == null ? undefined : json['filterNegativePower'],
        'filterNegativeWind': json['filterNegativeWind'] == null ? undefined : json['filterNegativeWind'],
        'filterNoPowerValues': json['filterNoPowerValues'] == null ? undefined : json['filterNoPowerValues'],
        'filterRefCurveTolerance': json['filterRefCurveTolerance'] == null ? undefined : json['filterRefCurveTolerance'],
        'hours': json['hours'] == null ? undefined : json['hours'],
        'generatorStatus': json['generatorStatus'] == null ? undefined : json['generatorStatus'],
        'windDirections': json['windDirections'] == null ? undefined : json['windDirections'],
        'windDirectionSteps': json['windDirectionSteps'] == null ? undefined : json['windDirectionSteps'],
        'generatorKeys': json['generatorKeys'],
    };
}

export function PowercurveDataRequestToJSON(json: any): PowercurveDataRequest {
    return PowercurveDataRequestToJSONTyped(json, false);
}

export function PowercurveDataRequestToJSONTyped(value?: PowercurveDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeFrom': value['timeFrom'],
        'timeTo': value['timeTo'],
        'windInterval': value['windInterval'],
        'filterNegativePower': value['filterNegativePower'],
        'filterNegativeWind': value['filterNegativeWind'],
        'filterNoPowerValues': value['filterNoPowerValues'],
        'filterRefCurveTolerance': value['filterRefCurveTolerance'],
        'hours': value['hours'],
        'generatorStatus': value['generatorStatus'],
        'windDirections': value['windDirections'],
        'windDirectionSteps': value['windDirectionSteps'],
        'generatorKeys': value['generatorKeys'],
    };
}

